module.exports = __webpack_public_path__ + "static/Bigger-Trees_mobile-70eb97aa981068b9b6f8a93137cf3242.webp";